/**
 * This file contains the REST API enums for Shopify,
 * these enums are different than the GraphQL versions.
 * Consolidating them here so we can eliminated them all someday
 */
// oxlint-disable-next-line @typescript-eslint/no-namespace
export var ShopifyRestEnum;
(function (ShopifyRestEnum) {
    ShopifyRestEnum.FinancialStatus = {
        pending: 'pending',
        authorized: 'authorized',
        partially_paid: 'partially_paid',
        paid: 'paid',
        partially_refunded: 'partially_refunded',
        refunded: 'refunded',
        voided: 'voided',
    };
    ShopifyRestEnum.financialStatusLabel = {
        pending: 'Pending',
        authorized: 'Authorized',
        partially_paid: 'Partially Paid',
        paid: 'Paid',
        partially_refunded: 'Partially Refunded',
        refunded: 'Refunded',
        voided: 'Voided',
    };
    ShopifyRestEnum.DisplayFulfillmentStatus = {
        //! unfulfilled is not real, on Shopify this is represented by null/undefined
        unfulfilled: 'unfulfilled',
        fulfilled: 'fulfilled',
        partial: 'partial',
        restocked: 'restocked',
    };
    ShopifyRestEnum.displayFulfillmentStatusLabel = {
        unfulfilled: 'Unfulfilled',
        fulfilled: 'Fulfilled',
        partial: 'Partially Fulfilled',
        restocked: 'Restocked',
    };
    ShopifyRestEnum.FulfillmentEventStatus = {
        attempted_delivery: 'attempted_delivery',
        carrier_picked_up: 'carrier_picked_up',
        confirmed: 'confirmed',
        delayed: 'delayed',
        delivered: 'delivered',
        failure: 'failure',
        in_transit: 'in_transit',
        label_printed: 'label_printed',
        label_purchased: 'label_purchased',
        out_for_delivery: 'out_for_delivery',
        picked_up: 'picked_up',
        ready_for_pickup: 'ready_for_pickup',
    };
})(ShopifyRestEnum || (ShopifyRestEnum = {}));
//# sourceMappingURL=shopifyRestEnum.js.map